export class CustomerListTotals {
  fromObject(object: any): CustomerListTotals {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public invoicesTotal: number;
  public paymentsTotal: number;
  public currentDebtSum: number;
  public oldDebtSum: number;
  public totalDebtSum: number;
}
